import React, { useState, useEffect, useContext } from 'react';
import {format} from "date-fns";

import * as net from "../../../../lib/net";
import Dd_Sel from "../../../../lib/ui/dd_sel";
import Td_Sel from "../../../../lib/ui/td_sel";

import Sell_Tr from "../sell_tr";

class Prd_Sz extends React.Component {
  constructor(props, context) {
    super(props);

     this.selitems = [
        {fkn: 'setup', text: 'INSTÄLLNINGAR'},
        {fkn: 'upd', text: 'UPPDATERA'},
        {fkn: 'sys', text: 'SYSTEM'},
        {fkn: 'logout', text: 'LOGGA UT'}
    ];

    this.fkn_close = null;
    this.state = {};
    this.state.ynq = [];

    this.state.paa = [];
    this.state.aa = [];
    this.state.selrow = {};
    this.state.srow = {};
    this.state.wnds = {};

    this.state.boknr = "";
    this.state.rvo = {};
    this.state.nta = [];
    if(props.wnds) {
        this.fkn_close = props.wnds.fkn_close;
        this.state.boknr = props.wnds.boknr;
        this.state.gso = props.wnds.gso;
        this.state.nta = props.wnds.nta;
    }

    this.state.today = new Date();
    var dts = format(this.state.today, "yyyy-MM-dd");
    this.state.dts = dts;

     this.state.tra = [];
     this.state.pays = [
        {betkod: 'kont', text: 'KONTANT', konto: "1910"},
        {betkod: 'fakt', text: 'FAKTURA', konto: "1910"},
        {betkod: 'mank', text: 'KORT MANUELL', konto: "1910"},
        {betkod: 'swish', text: 'SWISH', konto: "1910"}
    ];
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
      this.trs();
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }

    handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      var user = this.state.user;
      user[name] = value;
      this.setState({user: user});
      //setState({[name]: value});
    }
    wnd_close() {
      var self = this;
      if(self.props.wnds.cb) {
        var rsp = {};
        rsp.ok = "000";
          self.props.wnds.cb(self.props.ctx, rsp);
      }
      else self.props.ctx.setState({ wnds: {} });
	};
  tb_style() {
      var css = {};
      css.height = (window.innerHeight * 0.8) - 175;
      css.overflow = "auto";
      return css;
  }
  xrow_style(row) {
    var srow = this.state.srow;
    var css = {};
    if(srow[row.e1typ]) {
        css.background = "#080";
        css.color = "#fff";
    }
    return css;
  }
  row_style(row) {
    var srow = this.state.srow;
    var css = {};
    if(srow == row) {
        css.background = "#080";
        css.color = "#fff";
    }
    return css;
  }
  clear() {
    this.setState({srow: {}});
  }
  set_all() {
    var srow = this.state.srow;
    for(var row of this.state.tra) {
        srow[row.e1typ] = row;
    }
    this.setState({srow: srow});
  }
  xsel_row(row) {
    var srow = this.state.srow;

    if(srow[row.e1typ]) {
      delete( srow[row.e1typ] );
    }
    else srow[row.e1typ] = row;
    this.setState({srow: srow});
  }
  sel_row(row) {
    var srow = this.state.srow;

    if(srow == row) {
      srow = {};
    }
    else srow = row;
    this.setState({srow: srow});
  }
  trs() {
    var self = this;

    var prm = {};
    prm.req = "pms.tr.qs_trs";
    prm.typ = "T";

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({tra: ret.rca });
        self.syncTb("prdsTable");
    })
    .catch(function(e) {
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
    syncTb(tb){
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
        tdElements = tbel.getElementsByTagName('td');
        if(tdElements.length == 0) {
            //alert("No td");
             return;
       }

        for (let i = 0; i < thElements.length; i++) {
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
            width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }
  sz() {
  }
  val_date(val) {
      var ret = "";
      if(val) ret = val.toString().cdidate();
      return ret;
  }
  sell_sel() {
    var srow = this.state.srow;

    if(srow != {}) {
      this.sell_tr(srow);
    }
  }
  sell_tr(tro) {
    var self = this;

    var wnds = {};
    wnds.selltr = 1;
    wnds.boknr = this.state.boknr;
    wnds.gso = this.state.gso;
    wnds.tro = tro;
    wnds.cb = this.cb_sell_tr;
    this.setState({wnds: wnds});
  }

  cb_sell_tr(ctx, ret) {
      if(ret.ok == "000") {
          //ctx.charges();
          if(ctx.props.wnds.cb) {
            var rsp = {};
            rsp.ok = "000";
              ctx.props.wnds.cb(ctx.props.ctx, rsp);
          }
          else ctx.props.ctx.setState({ wnds: {} });
      }
    ctx.setState({wnds: {}});
  }

  render() {
    //if(!this.props.show) return "";

    var title = this.props.title;
    if(!title) title = "";

	var html =
        <div className="mx_base">
        { this.props.backdrop ? <div className="m2_backdrop" /> : null }
        <div className="m2_dlg mx_50hh flex-col" style={ this.dlg_style() }>
        <div className="flex-row " style={{padding:"0px",height:"50px",lineHeight:"50px", background: "#1a456b", color: "#fff"}}>
                <div className="flex-row flex" style={{padding:"0px 5px", fontSize: "22px"}}>
                    <div>PRODUKT SÖK { this.state.rumsnr }</div>
                </div>
            <div className="wnd-close-btn" onClick={() => this.wnd_close() }>X</div>
        </div>
        <div className="mx_content flex">

        <div className="web-col flex" style={{padding: "0px"}}>

        <div id="prdsTable" className="flex">
          <table className="table table-bordered table-hover tb" style={{marginBottom: "0px"}}>
            <thead>
            <tr>
                <th>Typ</th>
                <th>Konto</th>
                <th>Text</th>
                <th>Pris</th>
            </tr>
            </thead>
        </table>
        <div style={ this.tb_style() }>
          <table className="table table-bordered table-hover tb">
            <tbody>
            { this.state.tra.map((row, key) =>
            <tr key={key} style={ this.row_style(row) } onClick={ () => this.sel_row(row) } onDoubleClick={ () => this.sell_tr(row) }>
                <td>{ row.e1typ }</td>
                <td>{ row.e1kontonr }</td>
                <td>{ row.e1text }</td>
                <td>{ row.e1pris }</td>
            </tr>
            )}
            </tbody>
        </table>
        </div>
        </div>

        <div className="divider_orange"></div>

        <div className="web-row">
        <div className="web-col flex">
            <div className="wnd-btn" onClick={() => this.wnd_close() } >
                <div>STÄNG</div>
                <div></div>
            </div>
        </div>
         <div className="web-col flex" style={{padding: "0px 10px"}}>
       </div>
         <div className="web-col flex" style={{padding: "0px 10px"}}>
            <div className="wnd-btn" onClick={() => this.sell_sel() } >
                <div>VÄLJ</div>
                <div></div>
            </div>
       </div>
       </div>

        </div>

        </div>
      </div>
    { this.state.wnds.selltr ? <Sell_Tr wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
    </div>
	;
	return html;
  };
}

export default Prd_Sz;